import httpClient  from '.';

export default {
    //Lấy DS formula
    async getFormula() {
        let url = '/pbapi/api/formula';
        return await httpClient.get(url);
    },

    //Lấy DS tín hiệu user đã đăng ký
    async getSignals(userId) {
        let url = '/pbapi/api/usersignals/' + userId;
        return await httpClient.get(url);
    },

    async getResult(userId, signalId) {
        let url = '/pbapi/api/usersignals';
        return await httpClient.post(url, { userId: userId, signalId: signalId });
    },

    getSignal(userId, signalId) {
        let url = '/pbapi/api/usersignals/' + userId;
        return httpClient.get(url, {
            params: {
                signalId: signalId
            }
        });
    },

    async add(data) {
        let url = '/pbapi/api/usersignals/' + data.userID;
        return await httpClient.post(url, data);
    },

    async edit(data) {
        let url = '/pbapi/api/usersignals/' + data.userID + '/' + data.signalID;
        return await httpClient.put(url, data);
    },

    async delete(userId, signalId){
        let url = '/pbapi/api/usersignals/' + userId;
        return await httpClient.delete(url, {
            params: {
                signalId: signalId
            }
        });
    },
}